import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BlogService, BlogCategory, BlogAiGenerateRequest } from '@services/blog.service';
import { LanguageService } from '@services/language.service';
import { Language } from '@services/language.service';
import { PromptService, Prompt } from '@services/prompt.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-blog-ai-generate',
  templateUrl: './blog-ai-generate.component.html',
    styleUrls: ['./blog-ai-generate.css']
})
export class BlogAiGenerateComponent implements OnInit {
  form: FormGroup;
  categories: BlogCategory[] = [];
  languages: Language[] = [];
  prompts: Prompt[] = [];
  generating = false;

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private blogService: BlogService,
    private languageService: LanguageService,
    private promptService: PromptService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      promptId: ['', Validators.required],
      topic: ['', Validators.required],
      languageId: ['', Validators.required],
      blogCategoryId: ['', Validators.required],
      targetAudience: ['', Validators.required],
      keywords: ['', Validators.required],
      openAiApiKey: ['', Validators.required]
    });

    this.loadData();
  }

  loadData(): void {
    this.languageService.all().subscribe({
      next: (langs) => { this.languages = langs; },
      error: () => { this.toastr.error('Diller yüklenirken hata oluştu', 'Hata'); }
    });
    this.blogService.getCategories().subscribe({
      next: (cats) => { this.categories = cats; },
      error: () => { this.toastr.error('Kategoriler yüklenirken hata oluştu', 'Hata'); }
    });
    this.promptService.getAll().subscribe({
      next: (prompts) => { this.prompts = prompts; },
      error: () => { this.toastr.error('Promptlar yüklenirken hata oluştu', 'Hata'); }
    });
  }

  generate(): void {
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      this.toastr.warning('Lütfen tüm alanları doldurunuz', 'Uyarı');
      return;
    }

    this.generating = true;
    const request: BlogAiGenerateRequest = this.form.value;

    this.blogService.generateBlogWithAI(request).subscribe({
      next: () => {
        this.toastr.success('Blog yazısı AI tarafından oluşturuldu ve kaydedildi!', 'Başarılı');
        this.generating = false;
        this.activeModal.close(true);
      },
      error: (err) => {
        const msg = err?.error?.message || 'Bilinmeyen hata';
        this.toastr.error('Hata: ' + msg, 'Hata');
        this.generating = false;
      }
    });
  }

  close(): void {
    this.activeModal.dismiss();
  }
}
